var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stateBoxStyle"},[_c('div',{staticClass:"title"},[_c('h1',[_vm._v(_vm._s(_vm.stateBoxData.title))])]),_c('applicationMain',{attrs:{"stateBoxData":_vm.tableParams,"dictype":_vm.stateBoxData.dictype}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }